import {
  Box,
  IconButton,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { FC } from "react";

import { DraggableItem } from "views/orders/documents/new_documents/components/DraggableItem";
import { PartyItem } from "../../ron-schedule-meeting/services";
import { formatPartyRoles, truncatePartyName } from "../../ron-schedule-meeting/utils";

const useStyles = makeStyles((theme: any) => ({
  container: {
    backgroundColor: theme.palette.background.default,
    height: "2rem",
    display: "flex",
    alignItems: "center",
    borderBottom: `1px solid ${theme.palette.border.line}`,
    justifyContent: "space-between",
    borderRadius: '4px 4px 0px 0px',
    paddingLeft: "0.5rem"
  },
  partyName: {
    color: theme.palette.mode === 'dark' ? theme.palette.text.primary : theme.palette.primary.main
  },
  textContainer: {
    padding: "0.5rem", backgroundColor: theme.palette.background.paper
  },
  moveButton: {
    flex: "0 0 auto",
    padding: theme.spacing(0.5),
    marginRight: theme.spacing(0.5),
    fontSize: theme.typography.body2.fontSize,
    "&:focus-visible": {
      outline: `${theme.spacing(0.25)} solid ${theme.palette.primary.main}`,
      outlineOffset: -theme.spacing(0.25)
    }
  }
}));

export type MoveAction = {
  onClick: () => void;
  disabled?: boolean;
  ariaLabel: string;
  icon: IconProp;
};

type Props = {
  party: PartyItem,
  containerId?: string,
  moveAction?: MoveAction,
}

const stopDragStart = (event: React.SyntheticEvent) => event.stopPropagation();

export const PartyDroppableItem: FC<Props> = ({
  party: { _id, partyName, ...rest }, containerId, moveAction
}) => {
  const classes = useStyles();
  const roles = formatPartyRoles(rest.partyKinds);
  const displayName = truncatePartyName(partyName);

  return (
    <DraggableItem id={_id} containerId={containerId}>
      <Box>
        <Box className={classes.container}>
          <Typography variant="body1" className={classes.partyName}>{displayName}</Typography>
          {moveAction && (
            <IconButton
              type="button"
              size="small"
              color="primary"
              className={classes.moveButton}
              disabled={moveAction.disabled}
              onClick={moveAction.onClick}
              onPointerDown={stopDragStart}
              onMouseDown={stopDragStart}
              onTouchStart={stopDragStart}
              onKeyDown={stopDragStart}
              aria-label={moveAction.ariaLabel}
            >
              <FontAwesomeIcon icon={moveAction.icon} fixedWidth />
            </IconButton>
          )}
        </Box>
        <Box className={classes.textContainer}>
          <Typography>{rest.email}</Typography>
          <Typography variant="body2">{roles}</Typography>
        </Box>
      </Box>
    </DraggableItem>
  );
};
